import React from "react";
import ReactDOM from "react-dom";
import { HelmetProvider } from "react-helmet-async";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

import App from "./components/templates/App";
import ErrorBoundary from "./components/organisms/ErrorBoundary";
import { StoreContext } from "./contexts";
import store from "./store";
import { activity } from "./activity/instance";

import "./utilities/localization";
import "./styles/index.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

Bugsnag.start({
  // eslint-disable-next-line no-undef
  apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
  // enabledReleaseStages: ["production"],
  plugins: [new BugsnagPluginReact()],
  // eslint-disable-next-line no-undef
  // releaseStage: process.env.REACT_APP_RELEASE_TYPE,
});

// Member activity tracking: sends what is left from the last visit and reports app sessions.
activity.start();

ReactDOM.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      <React.StrictMode>
        <HelmetProvider>
          <StoreContext.Provider value={store}>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </StoreContext.Provider>
        </HelmetProvider>
      </React.StrictMode>
    </GoogleReCaptchaProvider>
  </GoogleOAuthProvider>,
  document.getElementById("root")
);
